import React, { useState, useRef, useEffect } from "react";
import styles from "./index.module.css";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";

const SwipeButtonRTL = ({ onComplete, loader, label, disabled, applyRest }) => {
  const [isSwiping, setIsSwiping] = useState(false);
  const [startX, setStartX] = useState(0);
  const [currentX, setCurrentX] = useState(0);

  const swipeIconRef = useRef(null);
  const swipeContainerRef = useRef(null);
  const swipeTextRef = useRef(null);

  // onSwipeStart
  const handleSwipeStart = (e) => {
    if (loader || disabled) return;

    setIsSwiping(true);
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    setStartX(clientX);
    setCurrentX(clientX);
    swipeIconRef.current.style.transition = "none"; // Disable transition during swipe
  };

  // onSwipeMove
  const handleSwipeMove = (e) => {
    if (!isSwiping || loader || disabled) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const deltaX = Math.max(0, startX - clientX); // Swiping right to left
    const maxSwipe =
      swipeContainerRef.current.offsetWidth - swipeIconRef.current.offsetWidth;
    setCurrentX(clientX);

    if (deltaX <= maxSwipe) {
      swipeIconRef.current.style.transform = `translateX(-${deltaX}px)`; // Move left
      swipeTextRef.current.style.setProperty("--mask-width", `${deltaX}px`);
    }
  };

  // onSwipeEnd (Determine action after swipe)
  const handleSwipeEnd = () => {
    if (!isSwiping || loader || disabled) return;

    setIsSwiping(false);
    const maxSwipe =
      swipeContainerRef.current.offsetWidth - swipeIconRef.current.offsetWidth - 10;
    const deltaX = Math.max(0, startX - currentX); // Swiped distance

    swipeIconRef.current.style.transition = "transform 0.3s ease";

    // If swiped more than 50% to the left, trigger the action
    if (deltaX >= maxSwipe / 2) {
      swipeIconRef.current.style.transform = `translateX(-${maxSwipe}px)`;
      swipeTextRef.current.style.setProperty("--mask-width", `${maxSwipe}px`);
      setTimeout(() => {
        onComplete(); // Trigger the swipe action
        if (applyRest) resetSwipe();
      }, 300);
    } else {
      resetSwipe();
    }
  };

  // Reset swipe to initial state
  const resetSwipe = () => {
    swipeIconRef.current.style.transition = "transform 0.3s ease";
    swipeIconRef.current.style.transform = "translateX(0)";
    swipeTextRef.current.style.setProperty("--mask-width", `0px`);
  };

  // Reset swipe when loader state changes to false
  useEffect(() => {
    if (!loader) {
      resetSwipe();
    }
  }, [loader]);

  return (
    <div
      className={`${styles["custom-swipe-container"]} ${
        loader ? styles["loading"] : ""
      } ${disabled ? styles["disabled"] : ""}`}
      ref={swipeContainerRef}
      onTouchMove={handleSwipeMove}
      onMouseMove={handleSwipeMove}
      onTouchEnd={handleSwipeEnd}
      onMouseUp={handleSwipeEnd}
      onMouseLeave={handleSwipeEnd}
      onTouchStart={handleSwipeStart}
      onMouseDown={handleSwipeStart}
    >
      {loader ? (
        <div className={styles["loader"]}></div>
      ) : (
        <>
          <div
            className={`${styles["custom-swipe-icon"]} ${
              loader ? styles["loading"] : ""
            }`}
            ref={swipeIconRef}
          >
            <MdKeyboardDoubleArrowLeft
              color={disabled ? "#d3d8dd" : "#2f4e6f"}
              size={22}
            />
          </div>
          <span className={styles["custom-swipe-text"]} ref={swipeTextRef}>
            {label}
          </span>
        </>
      )}
    </div>
  );
};

export default SwipeButtonRTL;
